import { Loader2, Square, Sparkles } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CHIPS_BUMI, CHIPS_LANGIT, KONTEKS } from "@/lib/hte";

export const Chip = ({ children, onClick, testid, active }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`px-3.5 h-9 rounded-full border text-sm transition-colors ${active ? "border-[var(--q)] text-q bg-q-soft" : "border-line text-mute hover:text-ink hover:border-[var(--mute)] bg-surface"}`}>
    {children}
  </button>
);

export const HteForm = ({ mod, input, setInput, konteks, setKonteks, loading, status, onSubmit, onCancel }) => {
  const chips = mod === "langit" ? CHIPS_LANGIT : CHIPS_BUMI;
  const label = mod === "langit" ? "Ayat Al-Quran" : "Isu atau masalah di lapangan";
  const ph = mod === "langit" ? "Contoh: 13:11, Ar-Ra'd 11, atau tampal teks ayat" : "Huraikan isu yang mahu diselesaikan…";
  return (
    <form className="surface rounded-2xl p-5 sm:p-7 space-y-5" onSubmit={(e) => { e.preventDefault(); onSubmit(); }} data-testid="hte-form">
      <div>
        <label htmlFor="hte-input" className="eyebrow block mb-2">{label}</label>
        {mod === "langit" ? (
          <input id="hte-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder={ph} data-testid="hte-input"
            className="w-full h-14 px-4 rounded-xl bg-bg border border-line text-lg text-ink placeholder:text-mute/70 focus:outline-none focus:border-[var(--q)] transition-colors" />
        ) : (
          <textarea id="hte-input" value={input} onChange={(e) => setInput(e.target.value)} placeholder={ph} rows={3} data-testid="hte-input"
            className="w-full px-4 py-3 rounded-xl bg-bg border border-line text-base text-ink placeholder:text-mute/70 focus:outline-none focus:border-[var(--q)] transition-colors resize-y" />
        )}
        <div className="flex flex-wrap gap-2 mt-3">
          {chips.map((c, i) => <Chip key={c} onClick={() => setInput(c)} testid={`example-chip-${i}`}>{c}</Chip>)}
        </div>
      </div>
      <div className="grid sm:grid-cols-[1fr_auto] gap-4 items-end">
        <div>
          <div className="eyebrow mb-2">Konteks aplikasi</div>
          <Select value={konteks} onValueChange={setKonteks}>
            <SelectTrigger className="h-12 rounded-xl bg-bg" data-testid="konteks-select"><SelectValue /></SelectTrigger>
            <SelectContent>{KONTEKS.map((k) => <SelectItem key={k} value={k} data-testid={`konteks-option-${k}`}>{k}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        {loading ? (
          <button key="cancel" type="button" onClick={onCancel} data-testid="hte-cancel-button"
            className="h-12 px-6 rounded-full border border-line text-ink inline-flex items-center justify-center gap-2 hover:bg-bg transition-colors">
            <Square size={14} /> Henti
          </button>
        ) : (
          <button key="submit" type="submit" disabled={!input.trim()} data-testid="hte-generate-button"
            className="h-12 px-7 rounded-full bg-ink text-bg font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-40 hover:opacity-90 transition-opacity">
            <Sparkles size={16} /> {mod === "langit" ? "Jana HTE" : "Cari ayat"}
          </button>
        )}
      </div>
      {loading && status && (
        <div className="flex items-center gap-3 text-sm text-mute" data-testid="hte-status" aria-live="polite">
          <Loader2 size={16} className="animate-spin text-q" /> <span>{status}</span>
        </div>
      )}
    </form>
  );
};
